import $ from 'jquery';
import ko from 'lib/knockout';
import * as widgets from './widgets';
import * as viewmodel from "./viewmodel";

export function init(options) {
	widgets.init();
	let model;

	model = viewmodel.init(options);

	ko.applyBindings(model, $('#shopCatalog')[0]);
}



// WEBPACK FOOTER //
// ./modules/shop/catalog/index.js